<template lang="pug">
.briq-form-element.briq-input
  label.input-label.type-bold(:for="name" v-if="label") {{ label }} 
  briq-required-and-optional-markers(:isRequired="isRequired" :hideOptionalMarker="hideOptionalMarker" :label="label")
  BriqTooltip.ml-5(:help="help")
  .flex.justify-center.items-center
    input.form-element.input(type='text' :ref="id" v-model="selectedDate" autocomplete="off")
    span.clear-button(title='clear' data-clear @click='clearDate()')
        BriqIcon(name='icon-input-trash-icon')
</template>
  
  <script>
  import { mapGetters } from 'vuex'
  import flatpickr from 'flatpickr'
  import { getWeekStartByLocale } from 'weekstart'
  import {
    getLocaleDateFormatStringForFlatPickr,
    convertDateFormatStringToFlatPickrDateFormat,
  } from '@/helpers/dateTimeFormatter.js'
  import 'flatpickr/dist/flatpickr.css';
  
  export default {
    name: 'NewBriqDateRangePicker',
    data() {
      return {
        selectedDate: ''
      }
    },
    props: {
      id: { type: [String, Number], required: true },
      name: { type: String, required: true },
      label: String,
      hideOptionalMarker: { type: Boolean, default: false },
      help: String,
      placeholder: { type: String, default: 'Select date' },
      value: String
    },
    computed: {
      ...mapGetters('briqState', ['businessUnitDataCulture']),
      localeDateFormatStringForFlatPickr() {
        return getLocaleDateFormatStringForFlatPickr(this.businessUnitDataCulture || this.$locale)
      },
      defaultDateFormatStringForFlatPickr() {
        return convertDateFormatStringToFlatPickrDateFormat(this.$defaultDateFormat)
      },
      flatPickrConfig() {
        return {
          dateFormat: this.defaultDateFormatStringForFlatPickr,
          altFormat: this.localeDateFormatStringForFlatPickr,
          locale: {
            firstDayOfWeek: this.firstDayOfWeek,
          },
          wrap: true,
        }
      },
      isRequired() {
        return this.$attrs.required || this.required
      },
      firstDayOfWeek() {
        return getWeekStartByLocale(this.$locale)
      },
    },
    watch: {
      value(newVal) {
        if (newVal === '') this.clearPickerInput()
        if (newVal) this.selectedDate = newVal
      }
    },
    methods: {
      pickerClosed() {
        setTimeout(() => {
          this.$emit('dateSelected', this.selectedDate)
        }, 10);
      },
      clearPickerInput() {
        this.selectedDate = ''
        const picker = this.$refs[this.id].flatpickr({
          mode: 'range',
          onClose: () => this.pickerClosed(),
          altInput: true,
          allowInput: true,
        })
        picker.clear()
      },
      clearDate() {
        this.clearPickerInput()
        this.$emit('dateSelected', '')
      },
    },
    mounted() {
      const picker = this.$refs[this.id]
      flatpickr(picker, {
        mode: 'range',
        onClose: () => this.pickerClosed(),
        altInput: true,
        allowInput: true,
      })
    },
    created() {
      if (this.value) this.selectedDate = this.value
    }
  }
  </script>
  
  <style scoped lang="stylus">
  .clear-button {
    cursor: pointer;
    padding: 4px;
    margin: 0 8px;
  
    svg {
      width: 16px;
      height: 16px;
      color: #4e5a6b;
    }
  }
  </style>
  